import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

export interface Props {
  balanceInfo?: number | string;
}

const BalanceCard: React.FC<Props> = ({
  balanceInfo = "",
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles["balance_card"]}>
      <div className={styles["balance_card__number"]}>
        <img src="assets/images/svg/wallet.svg" alt="wallet" />
        <div className={styles["text_wrapper"]}>
          <p className={classNames("p2", "g900")}>{t("lbl_wallets_balance")}</p>
          <h1 className={"done"}>{balanceInfo.toLocaleString()}</h1>
        </div>
        <span style={{ lineHeight: 3 }} className={"hint"}>
          {t("lbl_saudi_currency")}
        </span>
      </div>
    </div>
  );
};

export default BalanceCard;
